import type { AggregationCategory, AggregationItem } from './AggregationItems';

export default class AggregationItemsFactory {
    public static fromResponseData(data: HouseSearchResponse): AggregationCategory[] {
        return AggregationItemsFactory.fromArray(data.aggregations);
    }

    public static fromArray(aggregations: SearchResponseAggregation[]): AggregationCategory[] {
        return aggregations.map(
            (aggregation): AggregationCategory => ({
                name: aggregation.name,
                items: aggregation.fields.map(
                    (field): AggregationItem => ({
                        name: field.name,
                        count: field.count
                    })
                )
            })
        );
    }
}
